// Constants
export const BHK_OPTIONS = [
  "1 BHK",
  "2 BHK",
  "3 BHK",
  "3+ BHK",
  "1 RK / Studio",
];
export const LOCALITY_OPTIONS = [
  "Metro Station",
  "Airport",
  "School/Educational Institution",
  "Shopping mall",
  "Hospital",
  "Place of Worship",
  "Park/Play Ground",
];

export const LOCALITY_DETAILS_OPTIONS = [
  { key: "metro_station", label: "Metro Station" },
  { key: "airport", label: "Airport" },
  { key: "school", label: "School/Educational Institution" },
  { key: "shopping_mall", label: "Shopping mall" },
  { key: "hospital", label: "Hospital" },
  { key: "place_of_worship", label: "Place of Worship" },
  { key: "park", label: "Park/Play Ground" },
];

export const AMENITY_OPTIONS = [
  "Pool",
  "Gym",
  "Parking",
  "Lift",
  "Power Backup",
  "Garden",
  "Kids Play area",
  "Security & Cameras",
];

export const AMENITIES_OPTIONS = [
  { key: "pool", label: "Pool" },
  { key: "gym", label: "Gym" },
  { key: "parking", label: "Parking" },
  { key: "lift", label: "Lift" },
  { key: "power_backup", label: "Power Backup" },
  { key: "garden", label: "Garden" },
  { key: "kids_play_area", label: "Kids Play area" },
  { key: "security", label: "Security & Cameras" },
];

export const FURNISHING_OPTIONS = [
  "Unfurnished",
  "Semi Furnished",
  "Fully Furnished",
];
export const PREFERENCE_OPTIONS = [
  "Family",
  "Bachelors",
  "Corporate",
  "Anyone",
];
export const PROPERTY_TYPE = [
  "Apartment",
  "House",
  "Villa",
  "Studio",
  "PG",
  "Other",
];
